import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { PATHS } from '@/common';

import { PaymentDetailsPayload } from '../../TransactionDetails.types';
import { getDirectDepositInfo, getFormattedData } from '../utils/paymentDetails.utils';

interface Args {
  claimId?: string;
}

export const useGetClaimsPaymentDetails = (params: Args) => {
  const query = useQuery(
    [PATHS.CLAIMS_PAYMENT_DETAILS, params.claimId],
    () => {
      if (!params.claimId) return null;
      return api.get<PaymentDetailsPayload>(PATHS.CLAIMS_PAYMENT_DETAILS, {
        params: {
          claim_id: params.claimId,
        },
      });
    },
    {
      enabled: false,
      cacheTime: 0,
      retry: 0,
    }
  );

  const refetch = () => {
    if (params.claimId) {
      return query.refetch();
    }
    return Promise.resolve({} as any);
  };

  const formattedData = query.data ? getFormattedData(query.data.data) : undefined;
  const directDepositInfo = query.data ? getDirectDepositInfo(query.data.data) : undefined;

  return {
    ...query,
    formattedData,
    directDepositInfo,
    refetch,
  };
};
export default useGetClaimsPaymentDetails;
